export const INPUT_BORDER = 1

export const START_DATE = 'Start day'
export const END_DATE = 'End day'
